module.exports = [{
      plugin: require('../../../node_modules/gatsby-remark-images-datocms/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"start_url":"/","background_color":"#ff6000","theme_color":"#ff6000","display":"standalone","icon":"../../themes/gatsby-theme-multi-site/src/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"3aea18dc225176e32555ea4a072e4a3f"},
    },{
      plugin: require('../../../themes/gatsby-theme-multi-site/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
